import React from 'react';
import ReactDOM from "react-dom";
import Datamodal, {SIDE_PANEL_MODAL_TYPES} from "components/modal/dataModal";
import Modalstructure from "components/modal/components/structure";
import UseContext from "hooks/useContext";

const Index = () => {
    const {modalShow, modalType}=UseContext()

    if(!modalShow) return null

    return ReactDOM.createPortal(
        <Modalstructure
            isShowing={modalShow}
            placement={SIDE_PANEL_MODAL_TYPES.has(modalType) ? 'right' : 'center'}
        >
            <Datamodal/>
        </Modalstructure>
        , document.getElementById('root-portal'));
};

export default Index;